import React from 'react';
import BusinessFinancialReportPage from './BusinessFinancialReportPage';

export default function ReportMonthlyPage(props) {
  return <BusinessFinancialReportPage {...props} initialPeriod="month" />;
}
